import styled, { keyframes } from 'styled-components'

import { TDrawerStyle } from './types'

const subir = keyframes`
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
`

const aparecer = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

/**
 * Acima do TaBar, que é `position: fixed; bottom: 0` com `z-index: 1001` — o
 * maior do app. Nos 999/1000 que o Modal usa, a barra de navegação era pintada
 * por cima do sheet e cobria os botões de ação.
 */
const Z_ACIMA_DA_NAVEGACAO = 1002

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${Z_ACIMA_DA_NAVEGACAO};
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  animation: ${aparecer} 180ms ease-out;
`

export const Sheet = styled.div<TDrawerStyle>`
  position: relative;
  width: 100%;
  /* O reset global só aplica border-box em html e body, e não é herdado. */
  box-sizing: border-box;
  max-width: 520px;
  /*
   * A unidade dvh acompanha o teclado virtual; vh não. Com vh, abrir o teclado
   * num passo com campo de texto deixaria o sheet maior que a área visível e os
   * botões sairiam da tela. A linha em vh fica como fallback para navegador sem
   * suporte a dvh.
   */
  max-height: 85vh;
  max-height: 85dvh;
  overflow-y: auto;
  z-index: ${Z_ACIMA_DA_NAVEGACAO + 1};
  background: #fff;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.18);
  padding: 8px 20px 20px;

  /* O app roda como PWA: no iOS a barra inferior cobriria os botões. */
  padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));

  animation: ${subir} 220ms cubic-bezier(0.32, 0.72, 0, 1);

  transform: translateY(${(p: TDrawerStyle) => p.deslocamento}px);
  transition: ${(p: TDrawerStyle) =>
    p.arrastando ? 'none' : 'transform 220ms cubic-bezier(0.32, 0.72, 0, 1)'};

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    transition: none;
  }
`

export const Handle = styled.div`
  width: 100%;
  padding: 6px 0 10px;
  display: flex;
  justify-content: center;
  cursor: grab;
  touch-action: none;

  &::after {
    content: '';
    width: 40px;
    height: 4px;
    border-radius: 2px;
    background: #d9d9d9;
  }
`

export const Title = styled.h2`
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  color: #222;
`
